import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import amplitude from 'amplitude-js';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import { ListGroup, ListGroupItem } from 'reactstrap';
import Layout from '../../containers/Layout';
import Icon from '../../components/Icon';
import { ghaEditInstallationLink, ghaNewInstallationLink } from '../../utils/ghaLinks';
import SettingsDrawer from './components/SettingsDrawer';
export const defaultUrl = '/gha';
class SettingsGhaPage extends Component {
    constructor() {
        super(...arguments);
        this.handleInstallClick = (event, additional) => {
            event.preventDefault();
            amplitude.getInstance().logEvent('settings-install-gha-click', { additional });
            location.href = ghaNewInstallationLink(this.props.user.user);
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    renderList() {
        const { user: { user }, t, } = this.props;
        // eslint-disable-next-line id-length
        const installations = user?.ghaInstallations.sort((a, b) => a.login.localeCompare(b.login)) || [];
        if (!installations.length) {
            return null;
        }
        return (_jsx(ListGroup, { children: installations.map(({ installationId, login, suspended, type }) => (_jsxs(ListGroupItem, { className: "d-inline-flex", children: [_jsx("div", { className: "flex-grow-1", children: suspended ? _jsx("del", { children: login }) : login }), _jsx("div", { className: "text-right", children: _jsxs("a", { className: "d-block flex-grow-1", href: ghaEditInstallationLink({
                                installationId,
                                login,
                                type,
                                user,
                            }), rel: "noopener noreferrer", target: "_blank", children: [t('settings.settings'), " ", _jsx(Icon, { name: "external-link", size: "sm", className: "ml-2" })] }) })] }, installationId))) }));
    }
    render() {
        const { user: { user }, match, t, } = this.props;
        if (user && !user.gha) {
            return _jsx(Redirect, { to: "/settings" });
        }
        const hasInstallations = !!user?.ghaInstallations.length;
        return (_jsx(Layout, { title: t('settings.installedGhas'), loginRequired: true, withDrawer: true, match: match, loading: !user, titlePrimary: t('settings.settings'), children: _jsx("div", { className: "container repository-detail__container", children: _jsxs("div", { className: "row", children: [_jsx(SettingsDrawer, { className: "col col-12 col-md-2" }), _jsxs("div", { className: "col col-12 col-md-10 repository-detail__content", children: [_jsx("h2", { className: "repository-detail__title mb-1", children: t('settings.gha') }), _jsxs("div", { className: "container", children: [_jsx("h3", { className: "h5 text-muted mb-4", children: t('settings.installedGhaList') }), this.renderList(), hasInstallations ? (
                                        // @ts-expect-error TS2322: Type is not assignable
                                        _jsx("p", { align: "center", className: "mt-3", children: _jsx("a", { className: "btn btn-outline-secondary btn-sm ml-2", href: ghaNewInstallationLink(user), rel: "noreferrer", onClick: (event) => this.handleInstallClick(event, true), children: t('installGhaToAccount') }) })) : (_jsxs(_Fragment, { children: [_jsx("p", { align: "center", children: t('settings.noGhaInstallations', {
                                                        siteName: t('siteName'),
                                                    }) }), _jsx("p", { align: "center", children: _jsx("a", { className: "btn btn-outline-secondary btn-sm ml-2", href: ghaNewInstallationLink(user), rel: "noreferrer", onClick: (event) => this.handleInstallClick(event, false), children: t('installGhaNow') }) })] }))] })] })] }) }) }));
    }
}
const mapStateToProps = (state) => ({
    user: state.user,
});
export default connect(mapStateToProps)(withTranslation()(SettingsGhaPage));
